// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__13owk","colCheckbox":"styles_colCheckbox__3IDC_"};